import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

export const store =  new Vuex.Store({
  state: {
    chats:[],
    idToken: null,
    idUser: null,
    roles: [],
    errorLogin: false,
    dialogError: false,
    dialogErrorHeader: "Error en la aplicación",
    dialogErrorMessage: "Se ha presentado un error en el aplicativo. Vuelva a intentarlo más tarde",
    product:{id:"",code:"",name:"",brandId:""},
    users : [],
    usersByRol : [],
    allRols: [],
    companies : [],
    catalogs : [],
    parameters : [],
    rolesList: [],
    authenticated: false,
    progress: false,
    changePassword: false,
    totalDataFlow:0,
    totalPagesFlow:0,
    usersReport:[],
    menus : [],
    providers: [],
    vaccines:[],
    procedures:[],
    types:[],
    deviceUser:"",
    intervalMap:"",
    intervalReport:"",
    intervalMapDevice:""
},
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js